module.exports = __webpack_public_path__ + "img/IMG_5615_P-2_L_Foamcore.2a71c4ca.jpg";